import { Component, computed } from '@angular/core';
import { DynamicDialogButtonType } from '../../model';
import * as i0 from "@angular/core";
import * as i1 from "primeng/dynamicdialog";
import * as i2 from "@angular/common";
import * as i3 from "../../../icon-v2/icon.component";
import * as i4 from "primeng/divider";
import * as i5 from "@ngx-translate/core";
function ComplexDialogHeaderComponent_geaui_icon_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 4);
    i0.ɵɵlistener("click", function ComplexDialogHeaderComponent_geaui_icon_v2_4_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onExitDialog());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clickable", true)("color", "black")("file", ctx_r1.closeIcon);
  }
}
function ComplexDialogHeaderComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "p-divider");
    i0.ɵɵelementEnd();
  }
}
export class ComplexDialogHeaderComponent {
  ref;
  dynamicDialogConfig;
  closeIcon = '16px_close';
  config = computed(() => this.dynamicDialogConfig.data?.templateConfigService?.dialogConfig());
  headerConfig = computed(() => ({
    header: this.config()?.header ?? '',
    closable: this.config()?.closable ?? true,
    hideDividingLinesHeader: this.config()?.hideDividingLinesHeader ?? false,
    hideHeader: this.config()?.hideHeader
  }));
  constructor(ref, dynamicDialogConfig) {
    this.ref = ref;
    this.dynamicDialogConfig = dynamicDialogConfig;
  }
  onExitDialog() {
    this.ref.close({
      buttonType: DynamicDialogButtonType.Exit
    });
  }
  static ɵfac = function ComplexDialogHeaderComponent_Factory(t) {
    return new (t || ComplexDialogHeaderComponent)(i0.ɵɵdirectiveInject(i1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1.DynamicDialogConfig));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ComplexDialogHeaderComponent,
    selectors: [["geaui-complex-dialog-header"]],
    decls: 6,
    vars: 5,
    consts: [[1, "complex-dialog-header-content"], [1, "complex-dialog-title", "gea-font-heading-24"], ["class", "complex-dialog-close-icon", 3, "clickable", "color", "file", "click", 4, "ngIf"], ["class", "gea-divider", 4, "ngIf"], [1, "complex-dialog-close-icon", 3, "click", "clickable", "color", "file"], [1, "gea-divider"]],
    template: function ComplexDialogHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ComplexDialogHeaderComponent_geaui_icon_v2_4_Template, 1, 3, "geaui-icon-v2", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ComplexDialogHeaderComponent_div_5_Template, 2, 0, "div", 3);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, ctx.headerConfig().header));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.headerConfig().closable);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.headerConfig().hideDividingLinesHeader);
      }
    },
    dependencies: [i2.NgIf, i3.IconComponent, i4.Divider, i5.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplexDialogHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-complex-dialog-header',
      template: "<div class=\"complex-dialog-header-content\">\n  <span class=\"complex-dialog-title gea-font-heading-24\">{{ headerConfig().header | translate }}</span>\n  <geaui-icon-v2\n    class=\"complex-dialog-close-icon\"\n    *ngIf=\"headerConfig().closable\"\n    [clickable]=\"true\"\n    [color]=\"'black'\"\n    [file]=\"closeIcon\"\n    (click)=\"onExitDialog()\">\n  </geaui-icon-v2>\n</div>\n<div class=\"gea-divider\" *ngIf=\"!headerConfig().hideDividingLinesHeader\">\n  <p-divider></p-divider>\n</div>\n"
    }]
  }], () => [{
    type: i1.DynamicDialogRef
  }, {
    type: i1.DynamicDialogConfig
  }], null);
})();
